import { DatabaseModel, ModelJson } from "./database-model";

export class PartnerBarcode extends DatabaseModel {
    /**
     * Construct barcode object for storing lists of partner barcode (entrance tickets etc.) in the database
     */
    constructor(json: any = null, key: string = '') {
        super();
        this.key = key || json?.key || DatabaseModel.genKey();
        if(json) this.fromJson(json);
    }

    // Unique id of partner barcode instance
    key: string;
    // When the barcode was created in the system
    createdOn: number;
    // When the barcode was allocated to a voucher, if it was already allocated
    allocatedOn?: number;
    // Key of voucher that this barcode was allocated to, if already allocated (for now only used traceability and debug purposes)
    voucherKey?: string;
    // Project the barcode belongs to
    projectKey: string;
    // Id of the partner product that the barcode gives access to / is a ticket for ie. 'TivoliEntrance' (referenced by the Product)
    partnerProductId: string;
    // Unique barcode provided by the partner
    barcode: string;

    public fromJson(json: any) {
        this.createdOn = json.createdOn || null;
        this.allocatedOn = json.allocatedOn || null;
        this.voucherKey = json.voucherKey || '';
        this.projectKey = json.projectKey || '';
        this.partnerProductId = json.partnerProductId || '';
        this.barcode = json.barcode || '';
    }

    public toJson(): ModelJson {
        return {
            createdOn: this.createdOn,
            allocatedOn: this.allocatedOn,
            voucherKey: this.voucherKey,
            projectKey: this.projectKey,
            partnerProductId: this.partnerProductId,
            barcode: this.barcode,
        }
    }
}
